<template>
  <div
    :class="computedClass"
  >
    <div class="widget-title d-flex align-middle">
      <span class="title-label">{{ card.title }}</span>
    </div>
    <template v-if="card.value">
      <slot name="duration">
        <div :class="`duration duration-${type}`">
          <div class="value-wrapper">
            <h3>
              {{ formatValue(card.value, card.valueType) }}
            </h3>
            <InsightsMetric
              v-if="card.delta !== null"
              type="custom"
              :value="card.delta"
              :custom-value="formatValue(card.delta, card.valueType)"
            />
          </div>
          <div
            v-if="type === 'wide'"
            class="description"
          >
            {{ card.description }}
          </div>
        </div>
      </slot>
    </template>

    <div
      v-else
      class="d-flex gap-30 mb-16"
    >
      <div class="no-data">
        <img
          :src="IMAGE_EMPTY_BOX"
          alt="No data registered"
        />
        <span>No data</span>
      </div>
      <div
        v-if="type === 'wide'"
        class="description"
      >
        {{ card.description }}
      </div>
    </div>
    <div
      v-if="$slots.footer"
      class="footer"
    >
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

import InsightsMetric from '~/components/insights/InsightsMetric.vue';
import { IMAGE_EMPTY_BOX } from '~/rails_assets';
import { INSIGHTS } from '~/app_constants';

dayjs.extend(duration);

export default {
  name: 'InsightsGithubIntegrationCard',
  components: {
    InsightsMetric,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (val) => ['slim', 'wide'].indexOf(val) !== -1,
    },
  },
  data() {
    return {
      tooltipOptions: Object.freeze({
        placement: 'top',
      }),
      IMAGE_EMPTY_BOX,
      integrationConstants: INSIGHTS.integrations.github,
    };
  },
  computed: {
    computedClass() {
      return `card card-${this.type} card-${this.card.key} widget-common ${this.$slots.footer ? 'has-footer' : ''}`;
    },
  },
  methods: {
    formatValue(value, type) {
      switch (type) {
        case 'strict_count':
          return Math.floor(Math.abs(value));
        case 'count':
          return Math.abs(value).toFixed(2);
        case 'percentage':
          return `${Math.round(Math.abs(value))}%`;
        case 'duration':
          // eslint-disable-next-line no-case-declarations
          const duration = dayjs.duration(value, 'seconds');

          if (duration.days() === 0) {
            return `${Math.abs(duration.hours())}h`;
          }
 
            return `${Math.abs(duration.days())}d ${Math.abs(duration.hours())}h`;
          
        default:
          return value || '-';
      }
    },
  },
};
</script>
